import React from 'react';
import ContactForm from '../components/ContactForm';
import company from '../data/company';
import { generateGeneralWhatsAppLink } from '../data/products';
import { Phone, Mail, MessageSquare, MapPin, ShieldCheck } from 'lucide-react';
import { PRODUCT_IMAGES } from '../data/images';

const Contact = () => {
  return (
    <div style={{ paddingTop: 'calc(var(--nav-height) + 0px)', paddingBottom: '100px' }}>

      {/* Full-width Hero Image Banner */}
      <section style={{ position: 'relative', width: '100%', height: 'clamp(220px, 32vw, 380px)', overflow: 'hidden', marginBottom: '64px' }}>
        <img
          src={PRODUCT_IMAGES[4]}
          alt="RAYYAN DENIM Contact"
          fetchpriority="high"
          loading="eager"
          decoding="async"
          style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center center', display: 'block' }}
        />
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, rgba(15,23,42,0.3) 0%, rgba(15,23,42,0.78) 100%)' }} />
        <div style={{ position: 'absolute', bottom: '28px', left: 0, right: 0 }}>
          <div className="container" style={{ textAlign: 'center' }}>
            <span className="section-badge" style={{ background: 'rgba(255,255,255,0.15)', borderColor: 'rgba(255,255,255,0.4)', color: '#ffffff' }}>COMMUNICATIONS HUB</span>
            <h1 style={{ fontSize: 'clamp(30px, 5vw, 56px)', fontFamily: 'var(--font-heading)', fontWeight: 900, textTransform: 'uppercase', color: '#ffffff', marginTop: '10px' }}>
              LET'S TALK <span style={{ color: 'var(--accent-magenta)' }}>DENIM.</span>
            </h1>
            <p style={{ fontSize: 'clamp(14px, 1.6vw, 17px)', color: 'rgba(255,255,255,0.85)', marginTop: '6px' }}>
              Tell us what you're looking for and let's start the corporate conversation.
            </p>
          </div>
        </div>
      </section>

      <div className="container">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '48px', alignItems: 'start' }}>

          {/* Left Column: Direct Contact Info & Corporate Details */}
          <div>
            <div className="glass-panel" style={{ padding: '36px 30px', borderRadius: '16px', marginBottom: '28px' }}>
              <h2 style={{ fontSize: '20px', fontFamily: 'var(--font-heading)', color: 'var(--text-main)', marginBottom: '20px', textTransform: 'uppercase', fontWeight: 900 }}>
                DIRECT EXPORT DESK
              </h2>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

                {/* Phone */}
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                  <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: 'rgba(224, 0, 135, 0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--accent-magenta)', flexShrink: 0 }}>
                    <Phone size={20} />
                  </div>
                  <div>
                    <div style={{ fontSize: '12px', color: 'var(--text-subtle)', fontWeight: 700 }}>Phone Enquiries</div>
                    <a href={`tel:${company.phone}`} style={{ fontSize: '16px', fontWeight: 700, color: 'var(--text-main)' }}>
                      {company.phone}
                    </a>
                  </div>
                </div>

                {/* WhatsApp */}
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                  <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: 'rgba(37, 211, 102, 0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#25d366', flexShrink: 0 }}>
                    <MessageSquare size={20} />
                  </div>
                  <div>
                    <div style={{ fontSize: '12px', color: 'var(--text-subtle)', fontWeight: 700 }}>WhatsApp Instant Corporate Chat</div>
                    <a href={generateGeneralWhatsAppLink("Contact Page Direct")} target="_blank" rel="noopener noreferrer" style={{ fontSize: '16px', fontWeight: 700, color: '#25d366' }}>
                      Start WhatsApp Enquiry
                    </a>
                  </div>
                </div>

                {/* Email */}
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                  <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: 'rgba(224, 0, 135, 0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--accent-magenta)', flexShrink: 0 }}>
                    <Mail size={20} />
                  </div>
                  <div>
                    <div style={{ fontSize: '12px', color: 'var(--text-subtle)', fontWeight: 700 }}>Official Export Email</div>
                    <a href={`mailto:${company.email}`} style={{ fontSize: '16px', fontWeight: 700, color: 'var(--text-main)' }}>
                      {company.email}
                    </a>
                  </div>
                </div>

                {/* Address */}
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                  <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: 'rgba(224, 0, 135, 0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--accent-magenta)', flexShrink: 0 }}>
                    <MapPin size={20} />
                  </div>
                  <div>
                    <div style={{ fontSize: '12px', color: 'var(--text-subtle)', fontWeight: 700 }}>Corporate Headquarters</div>
                    <div style={{ fontSize: '14px', color: 'var(--text-muted)', lineHeight: '1.5', marginTop: '2px' }}>
                      {company.address}
                    </div>
                  </div>
                </div>

              </div>
            </div>

            {/* Assurance Card */}
            <div className="glass-panel" style={{ padding: '24px', borderRadius: '12px', borderLeft: '4px solid #25d366' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                <ShieldCheck size={20} style={{ color: '#25d366' }} />
                <span style={{ fontSize: '14px', fontWeight: 800, color: 'var(--text-main)' }}>DIRECT REPRESENTATIVE RESPONSE</span>
              </div>
              <p style={{ fontSize: '13px', color: 'var(--text-muted)', lineHeight: '1.5' }}>
                All export enquiries are routed directly to our senior export accounts manager for rapid technical review and quotation.
              </p>
            </div>
          </div>

          {/* Right Column: Interactive Contact Form */}
          <div>
            <ContactForm />
          </div>

        </div>
      </div>
    </div>
  );
};

export default Contact;
